import { FC } from 'react';
import CompanyDetail from './CompanyDetail';
import UseCompanyDetail from './UseCompanyDetail';

const CompanyDetailContainer: FC = () => {
  return <CompanyDetail {...UseCompanyDetail()} />;
};

export default CompanyDetailContainer;
